export function Spinner({
  size = 'md',
  label = 'Loading',
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  label?: string;
}) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12',
  };

  return (
    <div
      className={`animate-spin rounded-full border-2 border-slate-300 border-t-blue-500 ${sizeClasses[size]}`}
      role="status"
      aria-label={label}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}
